import {fromUtcTimeFormat} from "../../../shared/utils/dayjsUtil";

const parseLogData = (logString, record) => {
    if (!record.parsedLogData) {
        try {
            record.parsedLogData = JSON.parse(logString);
        } catch (error) {
            console.error('logString 파싱 오류:', error);
            record.parsedLogData = {};
        }
    }
    return record.parsedLogData;
};

const LOG_TYPE_TEXT = {
    Gain_PlazaPoint: '광장 포인트 획득',
    Spend_PlazaPoint: '광장 포인트 소모',
};

// 0: 일반 획득, 1: 수집왕 획득
const GAIN_ROUTE_TEXT = {
    0: '일반 획득',
    1: '수집왕 획득',
};

export const getPlazaPointLogColumns = () => {
    return [
        {
            title: '로그 타입',
            dataIndex: 'logString',
            render: (logString, record) => {
                const {logType} = parseLogData(logString, record);
                return LOG_TYPE_TEXT[logType] ? `${LOG_TYPE_TEXT[logType]}(${logType})` : logType;
            },
            filterMultiple: false,
            filters: [
                {text: '광장 포인트 획득', value: 'Gain_PlazaPoint'},
                {text: '광장 포인트 소모', value: 'Spend_PlazaPoint'},
            ],
            onFilter: (value, record) => parseLogData(record.logString, record).logType === value,
        },
        {
            title: '획득 경로',
            dataIndex: 'logString',
            render: (logString, record) => GAIN_ROUTE_TEXT[parseLogData(logString, record).gainRoute] ?? '',
        },
        {
            title: '광장 시즌 ID',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).seasonID,
        },
        {
            title: '재화 ID',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).currencyID,
        },
        {
            title: '카니발 활성화',
            dataIndex: 'logString',
            render: (logString, record) => {
                const {isCarnival} = parseLogData(logString, record);
                if (isCarnival === undefined || isCarnival === null || isCarnival === '') return '';
                return Number(isCarnival) === 1 ? 'O' : 'X';
            },
        },
        {
            title: '교환 보상 ID',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).exchangeRewardID,
        },
        {
            title: '변화 값',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).updatedValue,
        },
        {
            title: '최종 값',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).lastValue,
        },
        {
            title: '트리거 시간',
            dataIndex: 'logString',
            render: (logString, record) => {
                const {triggerTime} = parseLogData(logString, record);
                return triggerTime ? fromUtcTimeFormat(triggerTime) : '';
            },
        },
    ];
};
